import {
  Navbar,
  Container,
  Nav,
  Offcanvas,
  Badge,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Form } from "react-bootstrap";
import {
  faBagShopping,
  faHeart,
  faMagnifyingGlass,
  faUser,
  faWallet,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Green_btn from "../common-components/common_btn/green_btn/Green_btn";
import { useEffect, useRef, useState } from "react";
import Login_Modal from "../common-components/common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Success_Modal from "../common-components/common_modal/success_modal/Success_Modal";
import Cancel_Reason_Modal from "../common-components/common_modal/cancel_reason_modal/Cancel_Reason_Modal";
import OrderTrackModal from "../common-components/common_modal/order_track_modal/OrderTrackModal";
import { useDispatch, useSelector } from "react-redux";
import { myAccount } from "../../features/my_account/Slice";
import Cookies from "js-cookie";
import { getAllCart, postToLoginCart } from "../../features/cart/cartSlice";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import ListGroup from "react-bootstrap/ListGroup";
import { appSetup } from "../../features/master/masterSlice";

function Header() {
  const location = useLocation();

  // Reusable Tooltip Renderer with dynamic label
  const renderTooltip = (label) => (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {label}
    </Tooltip>
  );
  const [showSearch, setShowSearch] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const currentPath = location.pathname;
  const searchRef = useRef(null); // ✅ Ref for detecting outside click

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    dispatch(myAccount());
  }, [dispatch]);
  const isSignin = useSelector((state) => state.auth.is_signin);

  const allcartData = useSelector((state) => state.cart.allCarts);
  useEffect(() => {
    dispatch(getAllCart(isSignin));
  }, [dispatch]);

  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  useEffect(() => {
    dispatch(getAllWishlist());
  }, [dispatch]);

  useEffect(() => {
    const loginCart = async () => {
      if (isSignin) {
        const res = await dispatch(postToLoginCart());
        if (res.meta?.requestStatus === "fulfilled") {
        } else if (res.meta?.requestStatus === "rejected") {
          console.log("Error:", res.payload || "Login Cart Post Failed");
        }
      }
      await dispatch(getAllCart(isSignin));
    };

    loginCart();
  }, [dispatch, isSignin]);
  const [email, setEmail] = useState();
  const [contact, setContact] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const products = ["One", "Two", "Three", "Four", "Five"]; // Example product list

  const filteredItems = products.filter((item) =>
    item.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState();
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && searchTerm.trim() !== "") {
      navigate(`/shops?search=${encodeURIComponent(searchTerm)}`);
      // dispatch(PostSearchHistory({ name: searchTerm }));
    }
  };

  const handleSearchClick = async () => {
    if (searchTerm.trim() !== "") {
      navigate(`/shops?search=${encodeURIComponent(searchTerm)}`);
      // await dispatch(PostSearchHistory({ name: searchTerm }));
    }
  };

  // ✅ Detect click outside and hide search bar
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearch(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  return (
    <header className="Header theme_bg_colour">
      <Navbar expand="lg" className="">
        <Container>
          <div className="header_section_holder">
            {/* Mobile Toggle (only visible below lg) */}
            <Navbar.Toggle
              aria-controls="offcanvasNavbar"
              className="d-lg-none me-3 "
              onClick={handleShow}
            />

            {/* Offcanvas for mobile only */}
            <Navbar.Offcanvas
              show={showOffcanvas}
              onHide={handleClose}
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
              placement="start"
              className="d-lg-none mobile_view_header_offcanvas"
            >
              <Offcanvas.Header closeButton></Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="main-nav flex-column">
                  <Nav.Link
                    as={Link}
                    to="/"
                    className={currentPath === "/" ? "active" : ""}
                    onClick={handleClose}
                  >
                    Home
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/categories"
                    className={currentPath === "/categories" ? "active" : ""}
                    onClick={handleClose}
                  >
                    Shop by category
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className={currentPath === "/about-us" ? "active" : ""}
                    onClick={handleClose}
                  >
                    About Us
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/shops"
                    className={currentPath === "/shops" ? "active" : ""}
                    onClick={handleClose}
                  >
                    Shops
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/blog"
                    className={currentPath === "/blog" ? "active" : ""}
                    onClick={handleClose}
                  >
                    Blogs
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/contact"
                    className={currentPath === "/contact" ? "active" : ""}
                    onClick={handleClose}
                  >
                    Contact Us
                  </Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>

            <div className="header-icons mobile_view">
              <div
                className="icon-link"
                onClick={() => setShowSearch(!showSearch)}
              >
                <div className="icon_holder">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
              </div>
            </div>

            <div className="desktop_view_logo">
              {/* Logo */}
              <Navbar.Brand as={Link} to="/" className="brand-logo">
                <div className="logo_holder">
                  <img
                    // src="/assets/images/logo/og_vibe.png"
                    src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                    className="logo_img"
                  />
                </div>
              </Navbar.Brand>
            </div>

            {/* Desktop Navigation (visible lg and up) */}
            <div className="d-none d-lg-flex align-items-center justify-content-between w-100">
              <Nav className="main-nav me-auto">
                <Nav.Link
                  as={Link}
                  to="/"
                  className={currentPath === "/" ? "active" : ""}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/categories"
                  className={currentPath === "/categories" ? "active" : ""}
                >
                  Shop by category
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/about-us"
                  className={currentPath === "/about-us" ? "active" : ""}
                >
                  About Us
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/shops"
                  className={currentPath === "/shops" ? "active" : ""}
                >
                  Shops
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/blog"
                  className={currentPath === "/blog" ? "active" : ""}
                >
                  Blogs
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/contact"
                  className={currentPath === "/contact" ? "active" : ""}
                >
                  Contact Us
                </Nav.Link>
              </Nav>
            </div>
          </div>

            <div className="mobile_view_logo">
              {/* Logo */}
              <Navbar.Brand as={Link} to="/" className="brand-logo">
                <div className="logo_holder">
                  <img
                    // src="/assets/images/logo/new_ekansi_logo.png"
                    src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                    className="logo_img"
                  />
                </div>
              </Navbar.Brand>
            </div>

          <div className="header_section_holder">
            <div className="header-icons ">
              {/* 🔍 Magnifying Glass Icon */}
              <div
                className="icon-link desktop_view_search"
                onClick={() => setShowSearch(!showSearch)}
              >
                <div className="icon_holder">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
              </div>

              {/* {!isSignin && (
              
                <Link
                  className={`login_link ${
                    currentPath === "/login" ? "active" : ""
                  }`}
                >
                  <Green_btn
                    btnText="Login"
                    onClick={() => {
                      setShowLoginModal(true);
                    }}
                  />
                </Link>
              )} */}
              <Link
                to="/wishlist"
                className={`icon-link ${
                  currentPath === "/wishlist" ? "active" : ""
                }`}
              >
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip("Wishlist")}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faHeart} />
                    <Badge className="badge_holder">
                      {allWishlist?.data?.length || 0}
                    </Badge>
                  </div>
                </OverlayTrigger>
              </Link>
              <Link
                to="/product-cart"
                className={`icon-link ${
                  currentPath === "/product-cart" ? "active" : ""
                }`}
              >
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip("Cart")}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faBagShopping} />
                    <Badge className="badge_holder">
                      {allcartData?.data?.length || 0}
                    </Badge>
                  </div>
                </OverlayTrigger>
              </Link>
              {isSignin && (
                <Link
                  to="/wallet"
                  className={`icon-link ${
                    currentPath === "/wallet" ? "active" : ""
                  }`}
                >
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Wallet")}
                  >
                    <div className="icon_holder">
                      <FontAwesomeIcon icon={faWallet} />
                    </div>
                  </OverlayTrigger>
                </Link>
              )}
              {isSignin && (
                <Link
                  to="/account"
                  className={`icon-link ${
                    currentPath === "/account" ? "active" : ""
                  }`}
                >
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("My Account")}
                  >
                    <FontAwesomeIcon icon={faUser} />
                  </OverlayTrigger>
                </Link>
              )}

              {!isSignin && (
                <div
                  className="icon-link"
                  onClick={() => {
                    setShowLoginModal(true);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Container>
      </Navbar>
      <Container ref={searchRef}>
        <div className="row justify-content-center">
          <div className="col-md-6 col-12">
            {showSearch && (
              <div className="headsearch">
                <div className="searchdiv">
                  <Form.Control
                    placeholder="Search Product"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={handleKeyPress}
                    autoFocus
                  />
                  <button
                    type="submit"
                    className="searchbtn"
                    onClick={handleSearchClick}
                  >
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      className="search_icon"
                    />
                  </button>
                </div>

                <div
                  className="close_div"
                  onClick={() => {
                    setShowSearch(!showSearch);
                  }}
                >
                  <FontAwesomeIcon icon={faXmark} className="close_icon" />
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
        setShowLogin={() => setShowLogin(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Password Reseted Successfully!"
      />

      <Success_Modal
        show={showAccountCreted}
        onHide={() => {
          setShowAccountCreted(false);
        }}
        successText="Account Created Successful!"
      />

      <Success_Modal
        show={showLogin}
        onHide={() => {
          setShowLogin(false);
        }}
        successText="Login Successfully!"
      />
    </header>
  );
}

export default Header;
